import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  USER_NOTIFICATIONS_MODAL_LIST,
} from "./actionTypes"

import {
  userNotificationsModalListSuccess,
  userNotificationsModalListError,
} from "./actions"

import {
  apiGetUserNotificationsModalList,
} from "../../api/calls/userNotifications"

function* userNotificationsModalList({payload: data}) {
  try {
    const response = yield call(apiGetUserNotificationsModalList, data)
    yield put(userNotificationsModalListSuccess(response))
  } catch (error) {
    yield put(userNotificationsModalListError(error))
  }
}

export function* watchUserNotificationsModalList() {
  yield takeEvery(USER_NOTIFICATIONS_MODAL_LIST, userNotificationsModalList);
}

function* userNotificationsModalSaga() {
  yield all([
    fork(watchUserNotificationsModalList),
  ]);
}

export default userNotificationsModalSaga
